import { abi } from './abi';
import { CLAIMS_MANAGER_CONTRACT_ADDRESS } from './constants';
export class ClaimsManager {
    constructor(client, { address } = {}) {
        // Get the duration of a funding round in blocks
        this.getFundingRoundBlockDiff = () => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getFundingRoundBlockDiff'
        });
        // Get the last block where a funding round was initiated
        this.getLastFundedBlock = () => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getLastFundedBlock'
        });
        // Get the amount funded per round in wei
        this.getFundsPerRound = () => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getFundsPerRound'
        });
        // total amount claimed in the current round
        this.getTotalClaimedInRound = () => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getTotalClaimedInRound'
        });
        // Get the Governance address
        this.getGovernanceAddress = () => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getGovernanceAddress'
        });
        // Get the ServiceProviderFactory address
        this.getServiceProviderFactoryAddress = () => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getServiceProviderFactoryAddress'
        });
        // Get the DelegateManager address
        this.getDelegateManagerAddress = () => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getDelegateManagerAddress'
        });
        // Get the Staking address
        this.getStakingAddress = () => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getStakingAddress'
        });
        this.claimPending = ({ address }) => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'claimPending',
            args: [address]
        });
        this.client = client;
        this.address = address ?? CLAIMS_MANAGER_CONTRACT_ADDRESS;
    }
}
//# sourceMappingURL=claimsManager.js.map